export const GET_MAIN_BOARD_LIST_REQUEST = 'GET_MAIN_BOARD_LIST_REQUEST';
export const GET_MAIN_BOARD_LIST_SUCCESS = 'GET_MAIN_BOARD_LIST_SUCCESS';
export const GET_MAIN_BOARD_LIST_ERROR   = 'GET_MAIN_BOARD_LIST_ERROR';

export const GET_FIELDS_REQUEST = 'GET_FIELDS_REQUEST';
export const GET_FIELDS_SUCCESS = 'GET_FIELDS_SUCCESS';
export const GET_FIELDS_ERROR   = 'GET_FIELDS_ERROR';